enum SupportSender {
  SUPPORT_SENDER_TYPE = 'support',
}
export default SupportSender
